import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { ExportOutlined, UserOutlined, LogoutOutlined, ScanOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

const { Title, Text } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();
  const { userInfo, logout } = useAuthContext();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('退出失败:', error);
      // 即使退出失败也跳转到登录页
      navigate('/login');
    }
  };

  const handleOutbound = () => {
    navigate('/outbound');
  };

  const handleScanVerify = () => {
    navigate('/scan-verify');
  };

  return (
    <div>
      {/* 页面头部 */}
      <div className="page-header">
        <div>
          <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
            ERP手持系统
          </Title>
        </div>
        <Space>
          <Space>
            <UserOutlined />
            <Text>{userInfo?.name || userInfo?.userAccount || '用户'}</Text>
          </Space>
          <Button 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
            type="text"
          >
            退出
          </Button>
        </Space>
      </div>

      {/* 页面内容 */}
      <div className="page-content">
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <Title level={2} style={{ color: '#262626' }}>
            欢迎使用ERP手持系统
          </Title>
          <Text type="secondary" style={{ fontSize: 16 }}>
            请选择您要执行的操作
          </Text>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 24 }}>
          <Card
            hoverable
            style={{ 
              width: 300, 
              textAlign: 'center',
              borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
            }}
            bodyStyle={{ padding: 48 }}
          >
            <ExportOutlined 
              style={{ 
                fontSize: 64, 
                color: '#1890ff', 
                marginBottom: 24 
              }} 
            />
            <Title level={3} style={{ marginBottom: 16 }}>
              出库管理
            </Title>
            <Text type="secondary" style={{ fontSize: 16, marginBottom: 32, display: 'block' }}>
              扫码出库，库存管理
            </Text>
            <Button 
              type="primary" 
              size="large" 
              onClick={handleOutbound}
              style={{ 
                width: '100%', 
                height: 48, 
                fontSize: 18,
                borderRadius: 8
              }}
            >
              进入出库
            </Button>
          </Card>

          <Card
            hoverable
            style={{ 
              width: 300, 
              textAlign: 'center',
              borderRadius: 16,
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
            }}
            bodyStyle={{ padding: 48 }}
          >
            <ScanOutlined 
              style={{ 
                fontSize: 64, 
                color: '#52c41a', 
                marginBottom: 24 
              }} 
            />
            <Title level={3} style={{ marginBottom: 16 }}>
              扫码验证
            </Title>
            <Text type="secondary" style={{ fontSize: 16, marginBottom: 32, display: 'block' }}>
              快速扫码验证功能
            </Text>
            <Button 
              type="primary" 
              size="large" 
              onClick={handleScanVerify}
              style={{ 
                width: '100%', 
                height: 48, 
                fontSize: 18,
                borderRadius: 8,
                backgroundColor: '#52c41a',
                borderColor: '#52c41a'
              }}
            >
              扫码验证
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;